// extracted by mini-css-extract-plugin
export default {"bigContainer":"Reviews_bigContainer__tKq7Y","bigNumber":"Reviews_bigNumber__dUw08","reviewCards":"Reviews_reviewCards__tFzL9","eachCard":"Reviews_eachCard__3RnAH"};